import { m } from 'framer-motion';
import { directionVariants, buildTransition } from './motion-presets';
import { useMotionPreferences } from './useMotionPreferences';
import type { AnimatedContainerProps } from './types';

/**
 * Entrance animation wrapper.
 * Fades/slides children in on mount. Respects reduced-motion preferences.
 *
 * @example
 * <AnimatedContainer direction="up" delay={0.1}>
 *   <Card>...</Card>
 * </AnimatedContainer>
 */
export function AnimatedContainer({
  children,
  direction = 'up',
  duration = 'moderate',
  easing = 'smooth',
  delay,
  className,
}: AnimatedContainerProps) {
  const { shouldReduceMotion } = useMotionPreferences();

  if (shouldReduceMotion) {
    return <div className={className}>{children}</div>;
  }

  const variants = directionVariants[direction];
  const transition = buildTransition(duration, easing, delay);

  return (
    <m.div
      variants={variants}
      initial="hidden"
      animate="visible"
      exit="exit"
      transition={transition}
      className={className}
    >
      {children}
    </m.div>
  );
}
